import {
  getUserEmailFromCookies,
  getUserFirstNameFromCookies,
  getUserLastNameFromCookies
} from './getUserDetailsUtil'
import { KLAVIYO_PUBLIC_API_KEY } from '../../../constants/index'
import { headers } from './headers'

export const updateKlaviyoAddress = (city, state) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'profile',
        attributes: {
          email: getUserEmailFromCookies() ?? '',
          properties: {
            $city: city,
            $region: state,
          },
        },
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo upadting updateKlaviyoAddress success', response)
  })
  .catch(err => console.log('Filed to update klaviyo updateKlaviyoAddress', err))
}

export const updateKlaviyoPhoneNumber = (phoneNumber) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'profile',
        attributes: {
          email: getUserEmailFromCookies() ?? '',
          properties: {
            $phone_number: phoneNumber,
          },
        },
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo upadting updateKlaviyoPhoneNumber success', response)
  })
  .catch(err => console.log('Filed to update klaviyo updateKlaviyoAddress', err))
}

export const trackUserChangedPhoneNumber = async (phoneNumber) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            PhoneNumber: phoneNumber,
          },
          metric: {data: {type: 'metric', attributes: {name: 'User Updated Their Phone Number'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: getUserEmailFromCookies() ?? ''
              }
            }
          }
        }
      }
    })
  }

  await fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackUserChangedPhoneNumber success', response)
  })
  .catch(err => {
    console.log('Failed to track trackUserChangedPhoneNumber', err)
  })
}

export const subscribeUserPhone = async (phoneNumber) => {
  const options = {
    method: 'POST',
    headers: {
      accept: 'application/vnd.api+json',
      revision: '2025-01-15',
      'content-type': 'application/vnd.api+json'
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: getUserEmailFromCookies() ?? '',
                first_name: getUserFirstNameFromCookies() ?? '',
                last_name: getUserLastNameFromCookies() ?? '',
                phone_number: phoneNumber,
                subscriptions: {
                  sms: {
                    transactional: {
                      consent: "SUBSCRIBED",
                    },
                    marketing: {
                      consent: "SUBSCRIBED"
                    },
                  },
                },
              },
            }
          }
        },
        relationships: {list: {data: {type: 'list', id: 'R9hYxA'}}}
      }
    })
  }

  await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('Klaviyo sms subscription success', response)
  })
  .catch(err => {
    console.log('Failed klaviyo sms subscriptin', err)
  })
}

export const trackUserChangedLocation = async (city, state) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            City: city,
            State: state,
          },
          metric: {data: {type: 'metric', attributes: {name: 'User Updated Their Address'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: getUserEmailFromCookies() ?? ''
              }
            }
          }
        }
      }
    })
  }

  await fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackUserChangedLocation success', response)
  })
  .catch(err => {
    console.log('Failed to track trackUserChangedLocation', err)
  })
}
